import { useState } from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '@/components/feature/SeoHead';
import { categoriesData } from '@/mocks/categories';

export default function Categories() {
  const [activeTab, setActiveTab] = useState(categoriesData[0].id);

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'schema-breadcrumb-categories';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://jiuyou.com' },
        { '@type': 'ListItem', position: 2, name: '分类', item: 'https://jiuyou.com/categories' },
      ],
    });
    document.head.appendChild(script);
    return () => {
      const s = document.getElementById('schema-breadcrumb-categories');
      if (s) s.remove();
    };
  }, []);

  const activeCategory = categoriesData.find((c) => c.id === activeTab) || categoriesData[0];

  return (
    <>
      <SeoHead
        data={{
          title: '分类浏览 - jiuyou全方位内容导航 | jiuyou官网',
          description: '浏览jiuyou平台全部分类内容，包括平台介绍、使用教程、优惠活动、用户评价等，找到您需要的所有信息。',
          canonicalUrl: 'https://jiuyou.com/categories',
        }}
      />

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              探索 jiuyou 内容
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              选择您感兴趣的分类，发现更多精彩内容
            </p>
          </div>

          <div className="flex items-center justify-center gap-2 mb-12 flex-wrap">
            {categoriesData.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveTab(cat.id)}
                className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                  activeTab === cat.id
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} mr-2 text-base`} />
                {cat.name}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-1">
              <div className="sticky top-24 rounded-2xl overflow-hidden border border-background-200/70">
                <img
                  src={activeCategory.image}
                  alt={activeCategory.name}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-5 bg-background-50">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className={`${activeCategory.icon} text-xl`} />
                    </div>
                    <h2 className="text-lg font-heading font-semibold text-foreground-900">{activeCategory.name}</h2>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{activeCategory.description}</p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="space-y-4">
                {activeCategory.articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/articles/${article.slug}`}
                    className="block p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 group"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1 min-w-0">
                        <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2">
                          {article.title}
                        </h3>
                        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.summary}</p>
                        <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                          <span className="flex items-center gap-1">
                            <i className="ri-calendar-line" />
                            {article.date}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line" />
                            {article.readTime}
                          </span>
                        </div>
                      </div>
                      <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-hover:bg-primary-100 group-hover:text-primary-500 transition-all">
                        <i className="ri-arrow-right-line text-sm" />
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}